import { EntityName } from '@adm/backend-entity';

import { DeviceAction, Models, UserRole } from '../../enums';

export const devicePermissions: Record<
  UserRole,
  { actions: Array<keyof typeof DeviceAction>; subject: Models; fields?: Array<EntityName> }[]
> = {
  [UserRole.Admin]: [
    {
      actions: [
        DeviceAction.read,
        DeviceAction.create,
        DeviceAction.update,
        DeviceAction.delete,
        DeviceAction.installSim,
        DeviceAction.updateSim,
        DeviceAction.activate,
        DeviceAction.deactivate,
      ],
      subject: Models.Device,
    },
    { actions: [DeviceAction.read], subject: Models.Devices },
    { actions: [DeviceAction.sendCommand], subject: Models.DeviceSendCommandResponse },
    { actions: [DeviceAction.getCommandLog], subject: Models.CommandLogs },
    { actions: [DeviceAction.getDeviceJournal], subject: Models.DeviceJournal },
    { actions: [DeviceAction.getDeviceLogHistory], subject: Models.DeviceLogHistory },
    { actions: [DeviceAction.read, DeviceAction.create], subject: Models.BatchFirmwareUpdate },

    { actions: [DeviceAction.getLastPacket], subject: Models.LastPacket },
    { actions: [DeviceAction.getStatistics], subject: Models.StatisticsInfo },
    { actions: [DeviceAction.getTripsDaily], subject: Models.TripsDailyInfo },
  ],

  [UserRole.Operator]: [
    {
      actions: [
        DeviceAction.read,
        DeviceAction.create,
        DeviceAction.update,
        DeviceAction.delete,
        DeviceAction.installSim,
        DeviceAction.updateSim,
        DeviceAction.activate,
        DeviceAction.deactivate,
      ],
      subject: Models.Device,
    },
    { actions: [DeviceAction.read], subject: Models.Devices },
    { actions: [DeviceAction.sendCommand], subject: Models.DeviceSendCommandResponse },
    { actions: [DeviceAction.getCommandLog], subject: Models.CommandLogs },
    { actions: [DeviceAction.getDeviceJournal], subject: Models.DeviceJournal },
    { actions: [DeviceAction.getDeviceLogHistory], subject: Models.DeviceLogHistory },
    { actions: [DeviceAction.read, DeviceAction.create], subject: Models.BatchFirmwareUpdate },
    { actions: [DeviceAction.getLastPacket], subject: Models.LastPacket },
    { actions: [DeviceAction.getStatistics], subject: Models.StatisticsInfo },
    { actions: [DeviceAction.getTripsDaily], subject: Models.TripsDailyInfo },
  ],

  [UserRole.OperatorWithoutPBAccess]: [
    {
      actions: [
        DeviceAction.read,
        DeviceAction.create,
        DeviceAction.update,
        DeviceAction.delete,
        DeviceAction.installSim,
        DeviceAction.updateSim,
        DeviceAction.activate,
        DeviceAction.deactivate,
      ],
      subject: Models.Device,
    },
    { actions: [DeviceAction.read], subject: Models.Devices },
    { actions: [DeviceAction.sendCommand], subject: Models.DeviceSendCommandResponse },
    { actions: [DeviceAction.getCommandLog], subject: Models.CommandLogs },
    { actions: [DeviceAction.getDeviceJournal], subject: Models.DeviceJournal },
    { actions: [DeviceAction.getDeviceLogHistory], subject: Models.DeviceLogHistory },
    { actions: [DeviceAction.read, DeviceAction.create], subject: Models.BatchFirmwareUpdate },
    { actions: [DeviceAction.getLastPacket], subject: Models.LastPacket },
    { actions: [DeviceAction.getStatistics], subject: Models.StatisticsInfo },
    { actions: [DeviceAction.getTripsDaily], subject: Models.TripsDailyInfo },
  ],

  [UserRole.DeviceOperator]: [
    { actions: [DeviceAction.getLastPacket], subject: Models.LastPacket },
    { actions: [DeviceAction.getCommandLog], subject: Models.CommandLogs },
    { actions: [DeviceAction.getDeviceJournal], subject: Models.DeviceJournal },
    { actions: [DeviceAction.getDeviceLogHistory], subject: Models.DeviceLogHistory },
  ],

  [UserRole.OperatorReadAccess]: [
    { actions: [DeviceAction.read], subject: Models.Device },
    { actions: [DeviceAction.read], subject: Models.Devices },
    { actions: [DeviceAction.getLastPacket], subject: Models.LastPacket },
    { actions: [DeviceAction.getStatistics], subject: Models.StatisticsInfo },
    { actions: [DeviceAction.getTripsDaily], subject: Models.TripsDailyInfo },
    { actions: [DeviceAction.getCommandLog], subject: Models.CommandLogs },
    { actions: [DeviceAction.getDeviceJournal], subject: Models.DeviceJournal },
    { actions: [DeviceAction.getDeviceLogHistory], subject: Models.DeviceLogHistory },
    { actions: [DeviceAction.read], subject: Models.BatchFirmwareUpdate },
  ],

  [UserRole.TtmOperator]: [],

  [UserRole.DeviceQualityOperator]: [
    { actions: [DeviceAction.read], subject: Models.Device },
    { actions: [DeviceAction.read], subject: Models.Devices },
    { actions: [DeviceAction.getLastPacket], subject: Models.LastPacket },
    { actions: [DeviceAction.getCommandLog], subject: Models.CommandLogs },
    { actions: [DeviceAction.getDeviceJournal], subject: Models.DeviceJournal },
    { actions: [DeviceAction.getDeviceLogHistory], subject: Models.DeviceLogHistory },
    { actions: [DeviceAction.sendCommand], subject: Models.DeviceSendCommandResponse },
  ],
};
